import { render, staticRenderFns } from "./myChild.vue?vue&type=template&id=9b47678e&scoped=true&"
import script from "./myChild.vue?vue&type=script&lang=js&"
export * from "./myChild.vue?vue&type=script&lang=js&"
import style0 from "./myChild.vue?vue&type=style&index=0&id=9b47678e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b47678e",
  null
  
)

export default component.exports